// Переводы для страницы водителя
export const driverTranslations = {
  ru: {
    // Header
    refueling: 'Заправка',
    driver: 'Водитель',
    logout: 'Выход',
    
    // Form
    enterRefuelingData: 'Внести данные о заправке',
    selectBusAndEnter: 'Выберите автобус и введите данные',
    bus: 'Автобус',
    selectBus: 'Выберите автобус',
    currentMileage: 'Текущий пробег (км)',
    enterCurrentMileage: 'Введите текущий пробег',
    lastRecordedMileage: 'Последний зафиксированный пробег',
    litersRefueled: 'Литры заправлено',
    enterLiters: 'Введите количество литров',
    save: 'Сохранить',
    
    // Messages
    selectBusError: 'Выберите автобус',
    fillAllFieldsError: 'Заполните все поля',
    refuelingSaved: 'Заправка успешно сохранена!',
    refuelingSuccessMessage: 'Данные о заправке внесены в систему',
    savingError: 'Ошибка при сохранении',
    error: 'Ошибка',
    close: 'Закрыть',
    loading: 'Загрузка...',
    busesLoadError: 'Ошибка загрузки автобусов',
    km: 'км'
  },
  
  en: {
    // Header
    refueling: 'Refueling',
    driver: 'Driver',
    logout: 'Logout',
    
    // Form
    enterRefuelingData: 'Enter refueling data',
    selectBusAndEnter: 'Select bus and enter data',
    bus: 'Bus',
    selectBus: 'Select bus',
    currentMileage: 'Current mileage (km)',
    enterCurrentMileage: 'Enter current mileage',
    lastRecordedMileage: 'Last recorded mileage',
    litersRefueled: 'Liters refueled',
    enterLiters: 'Enter number of liters',
    save: 'Save',
    
    // Messages
    selectBusError: 'Select a bus',
    fillAllFieldsError: 'Fill in all fields',
    refuelingSaved: 'Refueling saved successfully!',
    refuelingSuccessMessage: 'Refueling data has been saved',
    savingError: 'Error saving',
    error: 'Error',
    close: 'Close',
    loading: 'Loading...',
    busesLoadError: 'Error loading buses',
    km: 'km'
  },
  
  lt: {
    // Header
    refueling: 'Kūro pylimas',
    driver: 'Vairuotojas',
    logout: 'Uždaryti',
    
    // Form
    enterRefuelingData: 'Įveskite kūro pylimo duomenys',
    selectBusAndEnter: 'Išrinkite autobusą ir įveskite duomenys',
    bus: 'Autobusas',
    selectBus: 'Pasirinkite autobusą',
    currentMileage: 'Dabartinė rida (km)',
    enterCurrentMileage: 'Įveskite ridą',
    lastRecordedMileage: 'Paskutinė užfiksuota rida',
    litersRefueled: 'Litrų užpilta',
    enterLiters: 'Įveskite litrų kiekį',
    save: 'Išsaugoti',
    
    // Messages
    selectBusError: 'Parinkite autobusą',
    fillAllFieldsError: 'Užpildykite visus laukus',
    refuelingSaved: 'Kūro pylimas išsaugotas',
    refuelingSuccessMessage: 'Kūro pylimo duomenys išsaugoti sistemoje',
    savingError: 'Klaida išsaugojant',
    error: 'Klaida',
    close: 'Uždaryti',
    loading: 'Kraunama...',
    busesLoadError: 'Klaida įkeliant autibusus',
    km: 'km'
  },
  
  pl: {
    // Header
    refueling: 'Tankowanie',
    driver: 'Kierowca',
    logout: 'Zamknij',
    
    // Form
    enterRefuelingData: 'Wprowadź dane dotyczące tankowania',
    selectBusAndEnter: 'Wybierz autobus i wprowadź dane',
    bus: 'Autobus',
    selectBus: 'Wybierz autobus',
    currentMileage: 'Aktualny przebieg (km)',
    enterCurrentMileage: 'Wprowadź przebieg',
    lastRecordedMileage: 'Ostatnio zarejestrowany przebieg',
    litersRefueled: 'Zatankowane litry',
    enterLiters: 'Wprowadź liczbę litrów',
    save: 'Zapisz',
    
    // Messages
    selectBusError: 'Wybierz autobus',
    fillAllFieldsError: 'Wypełnij wszystkie pola',
    refuelingSaved: 'Zapisane tankowanie',
    refuelingSuccessMessage: 'Dane o tankowaniu zapisane w systemie',
    savingError: 'Błąd zapisu',
    error: 'Błąd',
    close: 'Zamknij',
    loading: 'Ładowanie...',
    busesLoadError: 'Błąd ładowania autobusów',
    km: 'km'
  }
};
